import * as React from 'react'


export const Quote = ({ author, text, image }) => {
	return (
		<div className="c-quoteblock bg-grey-100">
			{image.localFile &&
			<div className="c-quoteblock__image">
				<img src={image.localFile.publicURL} alt={image.alt} />
			</div>}
			<div className="c-quoteblock__text">
				<div className="c-quoteblock__quote-text" dangerouslySetInnerHTML={{ __html: text }} />
				{author && <div className="c-quoteblock__quote-name">{author}</div>}
			</div>
		</div>
	)
}
